<div 
  class="subLabelLine text-base font-medium  mb-[0.25rem]"
  *ngIf="bcRootLvlLabel">
  <span
    [ngClass]="{'cursor-pointer': bcRootLvlPath != undefined, 'hover:text-[#818181]': bcRootLvlPath != undefined }"
    (click)="bcRootLvlPath != undefined ? goTo(bcRootLvlPath) : false">
  {{bcRootLvlLabel | translate}} <i class="text-lg relative top-[0.063rem] -left-[0.125rem]" [ngClass]="'icon-next'"></i>
  </span>
  <span *ngIf="bcRootLvl1Label"
    [ngClass]="{'cursor-pointer': bcRootLvl1Path != undefined, 'hover:text-[#818181]': bcRootLvl1Path != undefined }"
    (click)="bcRootLvl1Path != undefined ? goTo(bcRootLvl1Path) : false">
    {{bcRootLvl1Label | translate}} <i class="text-lg relative top-[0.063rem] -left-[0.125rem]" [ngClass]="'icon-next'"></i>
</span>
</div>